import {createEntityAdapter} from '@reduxjs/toolkit'
import {IPriceType} from '../../types'

export const priceTypesAdapter = createEntityAdapter<IPriceType>()